/* eslint-disable */
import { AxiosInstance, AxiosResponse } from 'axios'
import { Exactly } from './utils'

export type OperationWithAxiosResponse = <T extends Exactly<Request, T>>(request: T) => Promise<AxiosResponse<Response>>
export const operationWithAxiosResponse = <T extends Exactly<Request, T>>(axios: AxiosInstance, request: T): Promise<AxiosResponse<Response>> => {
  return axios.request({
    url: `/order/register`,
    // @ts-ignore for sm-axios
    urlTemplate: '/order/register',
    method: 'POST',
    data: request.body,
  })
}

/**
 * create the order link's login for a new email and set its password, which verifies the email
 */
export type Operation = <T extends Exactly<Request, T>>(request: T) => Promise<Response>
export const operation = async <T extends Exactly<Request, T>>(axios: AxiosInstance, request: T): Promise<Response> => {
  return (await operationWithAxiosResponse(axios, request)).data
}

export interface Request {
  body: {
    email: string
    partner: 'littlehotelier' | 'siteminder'
    password: string
    langCode?: string
  }
}

export interface Response {
  email: string
}

